module.exports = __webpack_public_path__ + "assets/images/sign-in-with-google.a535c9f19357915cdd5ae537d5d9ba4e.png";